import { AntTag } from '@agro-club/agroclub-shared'
import { Deal } from 'modules/domain/deal/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IconSpecification } from '../../Board/styled'

interface Props {
  deal: Deal
}

export const SpecificationTag: FC<Props> = ({ deal }) => {
  const { t } = useTranslation('deal')

  return (
    <AntTag
      icon={<IconSpecification $markSpecification={deal.mark_purchase_specification} />}
      color={deal.mark_purchase_specification ? 'blue' : 'grey'}
    >
      {t('specification')}
    </AntTag>
  )
}
